import { TranslatePipe } from '@ngx-translate/core';
import { Component, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogModule } from '@angular/cdk/dialog';

import { DialogTopComponent } from "../dialog-top/dialog-top.component";
import { DialogBottomComponent } from '../dialog-bottom/dialog-bottom.component';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrl: './dialog-confirm.component.scss',
    imports: [DialogTopComponent, DialogBottomComponent, DialogModule, TranslatePipe]
})
export class DialogConfirmComponent {

    readonly dialogRef = inject<MatDialogRef<DialogConfirmComponent>>(MatDialogRef);
    readonly data = inject<{
        title: string, message: string, data: any
    }>(MAT_DIALOG_DATA);

    submited: boolean = false;

    close = (e?: any): void => {
        this.dialogRef.close(this.submited);
    }

    onSubmit = (e?: any): void => {
        if (this.submited === false) this.submited = true;

        if(this.submited) this.close(true);
    }

}
